var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.2084 19.099C34.6485 18.1819 33.4514 17.8923 32.5343 18.4522C32.5343 18.4522 31.1297 19.0797 30.9221 18.8818C29.725 17.704 28.9189 16.1304 28.3687 14.5279C28.1804 13.9873 28.3783 13.3791 28.861 13.0702C29.0299 12.964 29.1651 12.906 29.1651 12.906C30.0822 12.3461 30.3718 11.149 29.8119 10.2319L28.7983 8.56663C27.1185 5.83458 23.5128 9.01553 23.5755 10.5505C23.5755 13.4273 24.2561 16.7531 25.7476 19.21C27.2488 21.6524 30.0774 24.9347 32.2978 24.8575C33.5142 24.9347 35.5704 23.4384 35.5704 23.4384C38.0997 21.9565 35.2084 19.099 35.2084 19.099Z",
    stroke: "#FDF3DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 8.46494C19.5 3.46611 24.2898 1.46611 29.9662 1.46611C36.8349 1.46611 43.9498 8.08866 43.9498 17.4095C43.9498 26.7303 33.5237 30.5339 27.268 30.5339C24.5 30.5339 20 28.9661 16.5 23.9661",
    stroke: "#FDF3DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 16.7627C9.16234 17.5784 17.706 16.5696 17.706 16.5696",
    stroke: "#FDF3DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9668 22.0722C14.5299 18.0755 18.1308 16.5695 18.1308 16.5695C15.2684 15.4689 11.9668 11.506 11.9668 11.506",
    stroke: "#FDF3DC",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCircle);
export default __webpack_public_path__ + "static/media/phone-circle.51df0c85d7f9ae174a597c408ecbc7b6.svg";
export { ForwardRef as ReactComponent };